import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const submit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success('Iscrizione completata. Usa il codice ESSENYA10');
      setEmail('');
    } catch { toast.error('Email non valida'); }
  };
  return (
    <section data-testid="newsletter-section" className="section-padding bg-essenya-champagne">
      <div className="container-essenya max-w-2xl text-center">
        <div className="text-eyebrow mb-3">Newsletter</div>
        <h2 className="text-4xl md:text-5xl font-display font-medium mb-4">Entra nel mondo ESSENYA.</h2>
        <p className="text-essenya-text mb-8 text-lg">Ricevi il 10% di sconto sul primo ordine e scopri in anteprima nuove profumazioni, bundle e offerte dedicate.</p>
        <form onSubmit={submit} className="flex gap-2 max-w-md mx-auto" data-testid="newsletter-form">
          <input value={email} onChange={e => setEmail(e.target.value)} type="email" required placeholder="La tua email" data-testid="newsletter-input" className="flex-1 bg-white border border-essenya-border rounded-lg px-4 py-3 outline-none focus:border-essenya-ink" />
          <button type="submit" data-testid="newsletter-submit" className="btn-primary">Ricevi il codice</button>
        </form>
        <p className="text-essenya-text text-xs mt-4">Niente spam. Solo novità, consigli e offerte utili.</p>
      </div>
    </section>
  );
}
